module.exports = __webpack_public_path__ + "static/media/game-medical-test-svgrepo-com.eb80dbae.svg";